import ProductRegItemCard from './product-reg-item-card'

export default ProductRegItemCard
